import axios from "axios";

export default class TaxonomyService {

    get() {
        return axios.get(`api/index.php/taxonomy`)
    }
}
